/* eslint-disable no-unused-vars */
import { axios } from './index'
import { mappingParamSearch } from '@/utils/page/menuSearch'
import cloneDeep from 'lodash/cloneDeep'
import { forEach } from 'lodash'

const resource = '/v1/stay'

export default {
  async getMenuBasicInfo(menuNo) {
    return axios.get(`${resource}/menu/${menuNo}`)
  },
  async getDPMenuBasicInfo(menuNo) {
    return axios.get(`${resource}/dp/menus/${menuNo}`)
  },
  async getMenuStay(menuNo, params = {}) {
    return axios.get(`${resource}/menu/${menuNo}/stay`, { params })
  },
  async getFacilities(params = {}) {
    // facilities/{latitude}/{longitude}?count=xyz&startIndex=xyz
    const queryParams = {
      count: params.pageSize ? params.pageSize : 10,
      startIndex: params.page ? +params.page - 1 : 0
    }
    return axios.get(
      `${resource}/menu/facilities/${params.latitude}/${params.longitude}`,
      { params: queryParams }
    )
  },
  async getSameCategoryMenus(queryParams = {}) {
    return axios.get(`${resource}/menu`, {
      params: {
        catLrgClassCd: queryParams.catLrgClassCd ? queryParams.catLrgClassCd : '',
        catMidClassCd: queryParams.catMidClassCd ? queryParams.catMidClassCd : '',
        catSmlClassCd: queryParams.catSmlClassCd ? queryParams.catSmlClassCd : '',
        count: queryParams.pageSize ? queryParams.pageSize : 10,
        startIndex: queryParams.page ? queryParams.page - 1 : 0
      }
    })
  },
  async getPhotoGallery(menuNo) {
    return axios.get(`${resource}/menu/${menuNo}/images`)
  },
  getFavourite(params) {
    return new Promise((resolve) => {
      axios.get(`${resource}/menu/favourite`, { params }).then(
        (response) => {
          resolve(response.data)
        },
        () => {
          resolve({})
        }
      )
    })
  },

  getVacancyCalendar(body) {
    return new Promise((resolve) => {
      axios.post(`${resource}/search/date/available`, body).then(
        (response) => {
          resolve(response.data)
        },
        (error) => {
          resolve(error)
        }
      )
    })
  },

  // 検索条件で空室状況を取得
  getSearchParamVacancyCalendar(menuNo, params = {}) {
    const data = cloneDeep(params)
    const redundant = [
      'category',
      'orderBy',
      'keyword',
      'rooms',
      'areaLrgClassCd',
      'areaMidClassCd',
      'areaSmlClassCd',
      'areaDtlClassCd'
    ]
    let queryParams = {}
    forEach(data, (value, key) => {
      if (!redundant.includes(key)) {
        queryParams[key] = value
      }
    })
    mappingParamSearch(queryParams, menuNo)

    return new Promise((resolve) => {
      axios.post(`${resource}/search/date/available/detail`, queryParams).then(
        (response) => {
          resolve(response.data)
        },
        (error) => {
          resolve(error)
        }
      )
    })
  },

  getRakutenInformation(rakutenHotelNo) {
    const params = {
      hotelNo: rakutenHotelNo
    };

    return new Promise((resolve) => {
      axios.get(`${resource}/menu/hotel-information-rakuten`, { params }).then(
        (response) => {
          resolve(response.data)
        },
        (error) => {
          resolve(error)
        }
      )
    });
  },
 
}
